import React, { FC } from 'react';

import { EvIcon, RemoveIcon } from '@evinced-private/ui-common';

import './RemoveIconButton.scss';

interface RemoveIconButtonProps {
	onClick: () => void;
	ariaLabel: string;
	className?: string;
}

export const RemoveIconButton: FC<RemoveIconButtonProps> = ({
	onClick,
	ariaLabel,
	className = ''
}) => {
	return (
		<button
			type="button"
			className={`remove-icon-button ${className}`}
			onClick={onClick}
			aria-label={ariaLabel}
		>
			<EvIcon icon={RemoveIcon} className="remove-icon-button__x_icon" />
		</button>
	);
};
